export default __webpack_public_path__ + "static/media/Cage Ladder.195bbb76.jpg";